export var state = {
  multiProjectSectionList: {},
  sections: []
};